import * as Icons from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { whyChooseUs } from "@/config/site";

export const WhyChooseUs = () => (
  <section data-testid="why-section" className="relative bg-ivory py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="text-center max-w-2xl mx-auto">
        <Reveal className="flex justify-center"><Eyebrow>Why Aarambh.KD</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl leading-tight text-charcoal">
            Reasons couples & companies
            <span className="italic text-maroon"> trust us.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {whyChooseUs.map((w, i) => {
          const Icon = Icons[w.icon] || Icons.Sparkles;
          return (
            <Reveal
              key={w.title}
              delay={(i % 4) * 0.08}
              className="group rounded-2xl border border-champagne/25 bg-white p-6 sm:p-8 text-center transition-all duration-500 hover:border-champagne hover:shadow-xl hover:shadow-champagne/10"
            >
              <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-maroon/5 transition-colors duration-500 group-hover:bg-maroon">
                <Icon className="h-6 w-6 text-maroon transition-colors duration-500 group-hover:text-champagne" strokeWidth={1.4} />
              </div>
              <p className="text-sm font-medium text-charcoal leading-snug">{w.title}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
